import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delivery-method-none-dialog',
  templateUrl: './delivery-method-none-dialog.component.html',
  styleUrls: ['./delivery-method-none-dialog.component.scss'],
})
export class DeliveryMethodNoneDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DeliveryMethodNoneDialogComponent>
  ) {}

  close() {
    this.dialogRef.close();
  }
}
